import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 border-t border-background-200/70 bg-secondary-950">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-12 md:grid-cols-4 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">
              91视频<span className="text-primary-500">在线观看</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            91视频在线观看是一个面向影视爱好者的在线观看平台，汇聚最新电影、热播电视剧与精彩综艺，支持多终端浏览与便捷筛选，让你随时随地找到想看的影片。
          </p>
          <p className="mt-4 text-xs leading-relaxed text-foreground-500">
            温馨提示：本平台播放区域为前端演示界面，不提供真实视频流播放服务；收藏功能仅保存在本设备浏览器中。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            <a href="#footer-nav" className="hover:text-primary-400">频道导航</a>
          </h4>
          <ul id="footer-nav" className="mt-4 flex flex-col gap-2 text-sm text-foreground-600">
            <li>
              <Link to="/" className="transition hover:text-primary-400">首页</Link>
            </li>
            <li>
              <Link to="/category/movie" className="transition hover:text-primary-400">电影频道</Link>
            </li>
            <li>
              <Link to="/category/tv" className="transition hover:text-primary-400">电视剧频道</Link>
            </li>
            <li>
              <Link to="/category/variety" className="transition hover:text-primary-400">综艺频道</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            <a href="#footer-help" className="hover:text-primary-400">帮助与关于</a>
          </h4>
          <ul id="footer-help" className="mt-4 flex flex-col gap-2 text-sm text-foreground-600">
            <li>
              <Link to="/search" className="transition hover:text-primary-400">搜索影视</Link>
            </li>
            <li>
              <Link to="/about" className="transition hover:text-primary-400">关于我们</Link>
            </li>
            <li>
              <Link to="/about#contact" className="transition hover:text-primary-400">联系我们</Link>
            </li>
            <li>
              <Link to="/about#legal" className="transition hover:text-primary-400">法律声明</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/50">
        <div className="mx-auto flex max-w-[1280px] flex-col gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <span>© {year} 91视频在线观看 · 本站内容均为演示示例，仅供产品展示使用</span>
          <span>本站不存储任何影视资源，所有播放演示均为前端模拟</span>
        </div>
      </div>
    </footer>
  );
}